const packageInfo = {
  name: 'tendo-cms-supplier',
  version: '1.0.0',
};

if (import.meta.env.PROD) {
  const variables = ['VITE_APOLLO_URI'];
  for (const variable of variables) {
    if (!import.meta.env[variable]) {
      throw new Error(`Kindly Provide Variable ${variable} In Env`);
    }
  }
}

const appEnv = import.meta.env.VITE_APP_ENV;

interface Config {
  env: 'production' | 'staging' | 'sandbox' | 'test' | 'development';
  name: string;
  asset: {
    uri: string;
  };
  apollo: {
    uri: string;
    name: string;
    version: string;
  };
  tenant: {
    domain: string;
  };
  sentry: {
    dsn: string;
    env: 'production' | 'staging' | 'sandbox' | 'test';
  };
  cookies: {
    domain: string;
    secure: boolean;
    sameSite: 'strict' | 'Strict' | 'lax' | 'Lax' | 'none' | 'None';
  };
  constants: {
    page: number;
    pageSize: number;
    dateFormat: string;
  };
  stripe: {
    key: string;
  };
}

const config: Config = {
  env: (import.meta.env.MODE as Config['env']) ?? 'development',

  name: packageInfo.name,
  asset: {
    uri: import.meta.env.VITE_ASSET_URI ?? 'http://127.0.0.1:4000/api/assets',
  },
  apollo: {
    // Note: The actual GraphQL requests go through Cloudflare Functions proxy at /graph
    // This URI is used for Apollo DevTools and codegen
    uri:
      appEnv === 'production'
        ? import.meta.env.VITE_APOLLO_URI!
        : '/graph',
    name: packageInfo.name,
    version: packageInfo.version,
  },
  sentry: {
    dsn:
      import.meta.env.VITE_SENTRY_DSN ??
      'https://examplePublicKey@o0.ingest.sentry.io/0',
    env: import.meta.env.VITE_SENTRY_ENV as Config['sentry']['env'],
  },
  tenant: {
    domain: import.meta.env.VITE_APP_TENANT_DOMAIN ?? 'tendo.one',
  },
  cookies: {
    domain: window.location.hostname?.split('.')?.slice(1)?.join('.'),
    secure: true,
    sameSite: 'strict',
  },
  constants: {
    page: 1,
    pageSize: 10,
    dateFormat: '',
  },
  stripe: {
    key: import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY ?? '',
  },
};

export default config;
